module.exports = __webpack_public_path__ + "img/shoot_00036.fef93eaa.png";